import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import DistrictWiseForm from "./DistrictWiseForm";

// Component function for rendering District wise ATM list
const DistrictWise = () => {
  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define grid layout configuration with header and form components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title="District wise ATMs"
          showdownload={true}
          fileName="District wise ATMs"
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 15,
      id: 1,
      component: <DistrictWiseForm />,
    },
  ];

  // Render grid container with layout items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};
export default DistrictWise;
